// App.js
import React from "react";
import "./App.css";
import GDLab from "./components/GdLab/GdLab";
import Login from "./components/Admin/Login";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import DentappLayout from "./components/Dentapp/DentappLayout";
import DentappLogin from "./components/Dentapp/Login/Login"
import Lab from "./components/Dentapp/Lab/Lab";
import Settings from "./components/Dentapp/Settings/Settings";
import Job from "./components/Dentapp/Job/Job";
import Statistic from "./components/Dentapp/Statistic/Statistic";
import Diary from "./components/Dentapp/Diary/Diary";
import Cooperation from "./components/Dentapp/Cooperation/Cooperation";

const App = () => {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<GDLab />} />
          <Route path="/admin" element={<Login />} />
          {/* Dentapp namespace */}
          <Route path="/dentapp" element={<DentappLayout />}>
            <Route path="login" element={<DentappLogin />} />
            <Route path="lab" element={<Lab />} />
            <Route path="settings" element={<Settings />} />
            <Route path="job" element={<Job />} />
            <Route path="statistic" element={<Statistic />} />
            <Route path="diary" element={<Diary />} />
            <Route path="cooperation" element={<Cooperation />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
};

export default App;
